import userReducer from "./Reducer";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
    userReducer
})

export default rootReducer